import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import baseStyles from '../../base/outline-element/outline-element.base.css.lit';
import utilityStyles from '../../base/outline-element/outline-element.utilities.css.lit';
import baseHeadingStyles from '../../base/outline-heading/outline-heading.css.lit';
import headingStyles from '../idb-heading/idb-heading.css.lit';
import componentStyles from './idb-styled-text.css.lit';
import { OutlineStyledText } from '../../base/outline-styled-text/outline-styled-text';
// @ts-ignore
import MultiClamp from 'multi-clamp';

/**
 * The IDB Styled Text component
 * @element idb-styled-text
 * @slot - default slot supplied by idb-styled-text
 */
@customElement('idb-styled-text')
export class IdbStyledText extends OutlineStyledText {
  static styles: CSSResultGroup = [
    baseStyles, // Styles from outline-element. Primarily to include @tailwind base;
    utilityStyles, // Styles from outline-element. Primarily to include @tailwind utilities;
    baseHeadingStyles, // Styles from outline-heading.
    headingStyles, // Styles from idb-heading, a specific component we want to represent in the WYSIWYG.
    componentStyles, // Styles specific to idb-styled-text.
  ];

  /**
   * Whether the button is disabled. Only applies to
   * implementations not using the url property
   */
  @property({ type: Boolean, attribute: 'text-xl' })
  textXL = false;

  connectedCallback() {
    super.connectedCallback();
    if (this.getAttribute('clamp') === 'true') {
      const styledText = this.querySelector('idb-styled-text');
      const div = styledText?.children[0]

      new MultiClamp(div, {
        disableCssClamp: true,
        ellipsis: '...',
        clamp: 3
      });
    }
  }

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}
